import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M19 2h1a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h1v1H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-1V2zm-1.067 10h.887a.5.5 0 0 1 .407.79l-1.529 2.14a.5.5 0 0 1-.813 0l-1.529-2.14a.5.5 0 0 1 .407-.79h1.17a5 5 0 0 0-8.287-3.768.5.5 0 1 1-.72-.676l-.01-.013A6 6 0 0 1 17.933 12zM16 2v1H8V2h8zM6.5 1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2a.5.5 0 0 1 .5-.5zm11 0a.5.5 0 0 1 .5.5v2a.5.5 0 1 1-1 0v-2a.5.5 0 0 1 .5-.5zm-2.892 16.372a6 6 0 0 1-8.67-5.11H4.764a.5.5 0 0 1-.407-.79l1.529-2.14a.5.5 0 0 1 .813 0l1.529 2.14a.5.5 0 0 1-.407.79h-.88a5 5 0 0 0 7.263 4.194l.002.004a.5.5 0 0 1 .572.812l.007.01-.054.028a.498.498 0 0 1-.122.062z"
});

var SvgRecurringOrder = function SvgRecurringOrder(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgRecurringOrder;